// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__oVDI5","bigColWidth":"Table_bigColWidth__3WTHD","biggerColWidth":"Table_biggerColWidth__3cq5C","row":"Table_row__3Y5Lp","col":"Table_col__2711q"};